import { useEffect } from 'react';

const FLASH_TITLE = 'Incoming call…';
const FLASH_MS = 800;

export function useIncomingCallTabFlash(isIncoming: boolean) {
  useEffect(() => {
    if (!isIncoming) return;

    const originalTitle = document.title;
    let intervalId: number | undefined;

    const stopFlash = () => {
      if (intervalId !== undefined) {
        window.clearInterval(intervalId);
        intervalId = undefined;
      }
      document.title = originalTitle;
    };

    const startFlash = () => {
      if (intervalId !== undefined) return;
      let showIncoming = true;
      document.title = FLASH_TITLE;
      intervalId = window.setInterval(() => {
        document.title = showIncoming ? originalTitle : FLASH_TITLE;
        showIncoming = !showIncoming;
      }, FLASH_MS);
    };

    const onVisibilityChange = () => {
      if (document.hidden) startFlash();
      else stopFlash();
    };

    if (document.hidden) startFlash();
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      stopFlash();
    };
  }, [isIncoming]);
}
